<accordion
  class="card"
  [ngClass]="{ 'box-shadow-none': customClass === 'timeline-accordion' }"
  [ngStyle]="ngStyleAccordion"
>
  <accordion-group
    [panelClass]="customClass"
    [isOpen]="accordionOpen"
    (isOpenChange)="changeStatus($event)"
    [ngClass]="{ 'box-shadow-none': customClass === 'timeline-accordion' }"
    [ngStyle]="ngStyleAccordionGroup"
  >
    <div class="accordion-heading" accordion-heading>
      <h3
        class="card-head"
        [ngClass]="customClassText"
        [ngStyle]="ngStyleTitle"
        *ngIf="title"
      >
        {{ title }}
      </h3>

      <span
        class="fa fa-check-circle-o"
        *ngIf="
          status === statusAccodionEnum.FINALIZADO ||
          status === statusAccodionEnum.EM_ANDAMENTO
        "
        [ngClass]="{
          'color-green': status === statusAccodionEnum.FINALIZADO,
          'color-yellow': status === statusAccodionEnum.EM_ANDAMENTO
        }"
      ></span>
      <span
        class="fa fa-times-circle-o"
        *ngIf="status === statusAccodionEnum.PENDENTE"
        [ngClass]="{
          'color-red': status === statusAccodionEnum.PENDENTE
        }"
      ></span>
    </div>

    <ng-content></ng-content>
  </accordion-group>
</accordion>
